import React from 'react';

import {
    ENTRI_LISTING_BASE_URL,
    VernacularCohortBanner as GlobalizationVernacularCohortBanner,
} from '@udemy/react-globalization-components';

import styles from './vernacular-cohort-banner.module.less';

/**
 * Udemy x Entri vernacular cohort banner for LOHP, placed directly below the hero.
 * Visibility is gated inside the package via `vernacular_cohort_banner` / `showVernacularCohortBanner`.
 */
export const VernacularCohortBanner = () => (
    <div className={styles['vernacular-cohort-banner']} data-purpose="vernacular-cohort-banner">
        <GlobalizationVernacularCohortBanner
            context={{entryPoint: 'lohp'}}
            entriListingBaseUrl={ENTRI_LISTING_BASE_URL}
            className={styles['vernacular-cohort-banner-spacing']}
        />
    </div>
);
